module.exports = __webpack_public_path__ + "img/logo.b9d1e99c.svg";